module.exports = __webpack_public_path__ + "static/media/comment-dollar.a30a7540.svg";